const getChannelName = (sectionName, path) => {
  let channelName = 'toi';
  if (sectionName !== '') {
    if (
      sectionName === 'entertainment' ||
      sectionName === 'Entertainment' ||
      sectionName === 'etimes' ||
      sectionName === 'Etimes' ||
      sectionName === 'Lifestyle' ||
      sectionName === 'lifestyle'
    ) {
      channelName = 'Etimes';
    } else {
      channelName = 'toi';
    }
  }
  if (
    path.indexOf('/gadgets-news/') > -1 ||
    path.indexOf('/technology/') > -1
  ) {
    channelName = 'GN';
  }
  if (
    path.indexOf('/web-series/') > -1 ||
    path.indexOf('/life-style/') > -1 ||
    path.indexOf('/tv/') > -1
  ) {
    channelName = 'Etimes';
  }
  if (path.indexOf('/food-news/') > -1) {
    channelName = 'recipe';
  }
  if (path.indexOf('/auto/') >= 0) {
    channelName = 'AN';
  }
  if (path.indexOf('/life-style/travel/') >= 0) {
    channelName = 'travel';
  }

  return channelName;
};

export default getChannelName;
